<script lang="ts">
    import translate from '../../../../../lib/translate'
    import { currentProductStore as product } from '../../../stores'
    import label from './ProductInfo.translation'
</script>

{#if $product}
    <div class="auction-product-image">
        <img loading="lazy" draggable="false" src="{$product.image.size300}" alt="{$product.name}">
    </div>
    <div class="auction-product">
        <p class="auction-product-name">{$product.name}</p>
        <p class="auction-product-sku">
            <span class="label">{translate(label.articleNumber)}</span>
            <span class="value">{$product.productId}</span>
        </p>
        {#if $product.variants.length === 1}
            {#if $product.variants[0].material}
                <p class="auction-product-variant-material">
                    {translate(label.variantMaterial($product.variants[0].material))}
                </p>
            {/if}
            {#if $product.variants[0].ringsize}
                <p class="auction-product-variant-ringsize">
                    {translate(label.ringsize)}
                    {translate(label.variantRingsize($product.variants[0].ringsize))}
                </p>
            {/if}
        {/if}
    </div>
{/if}